import { render, staticRenderFns } from "./ModifyClientAccessPassword.vue?vue&type=template&id=383a6d18&"
import script from "./ModifyClientAccessPassword.vue?vue&type=script&lang=js&"
export * from "./ModifyClientAccessPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports